import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { MAP_LIST } from '$http';
import areaSelect from 'area-select';

export default {
    components: { 'area-select': areaSelect },
    props: {
        value: {
            type: Boolean,
            default: false,
            require: true
        }
    },
    data() {
        return {
            visible: false,
            projectType: MAP_LIST.INTENT_PROJECT,
            Auditstatus: [{ id: '-1', text: '全部' }, { id: '0', text: '待审核' }, { id: '1', text: '未审核通过' }, { id: '2', text: '审核已通过' }],
            type: [{ id: '-1', text: '全部' }, { id: '0', text: '报备申请' }, { id: '1', text: '延期申请' }, { id: '2', text: '转正申请' }],
            Schoolstatus: [{ id: "1", text: "驳回" }, { id: "0", text: "新增" }],
            form: this.getInitFormData(),
            ProjectTypes: [],
            areaInfo: this.getInitAreaData()
        }
    },
    watch: {
        value(val) {
            this.visible = val;
        },
        visible(val) {
            this.$emit('input', val);
        }
    },
    created() {
        this.visible = this.value;
    },
    computed: {
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    methods: {
        getInitFormData() {
            return cloneDeep({
                SchoolName: "",//园所名称
                PrincipalName: "",//园长
                PhoneNo: "",//电话
                createTimeStart: "",//开始时间
                createTimeEnd: "",//创建结束时间
                SchoolStatus: "",//园所状态
                StatusType: "",//类型
                AuditStatus: "",//审核状态
                AgentCustomerId: "",
                ProjectTypes: ""
            });
        },
        getInitAreaData() {
            return cloneDeep({
                Provinces_Id: '',
                City_Id: '',
                Area_Id: ''
            });
        },
        search() {
            this.form.ProjectTypes = this.ProjectTypes.join(",");
            let params = Object.assign({}, this.form, {
                ProvId: this.areaInfo.Provinces_Id,
                CityId: this.areaInfo.City_Id,
                AreaId: this.areaInfo.Area_Id
            });
            this.$emit("search", params);
        },
        reset() {
            this.form = this.getInitFormData();
            this.areaInfo = this.getInitAreaData();
            this.$refs["areaForm"].cityList = [];//城市列表
            this.$refs["areaForm"].areaList = [];//区\县列表
            var a = Object.assign({}, this.form, this.areaInfo);
            this.ProjectTypes = [];
            this.$emit("search", a);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/purposeSchool/search/vm.js